/*
 * collection-size-sheet.js
 *
 * Drives the inline "Select Size" panel on collection product cards
 * (snippets/product-grid-size-sheet.liquid). This is NOT a modal — it swaps the
 * card's lower content in place.
 *
 * - "CHOOSE SIZE" ([data-open-sizes]) adds .osi-is-selecting to that card's
 *   .product__grid__info, which (via CSS) swaps ONLY the CHOOSE SIZE button for
 *   the size panel — the image/title/rating/description above stay put.
 * - Size pills ([data-size-option]) select a variant: highlight it, update the
 *   panel's hidden name="id" input, and refresh the Add button price.
 * - ADD TO CART is the theme's own product-add-button-form button, so the add +
 *   cart drawer/popdown is native. We just revert the card once the cart changes.
 */
(function () {
  'use strict';

  var ACTIVE = 'osi-is-selecting';

  function cardOf(el) {
    return el.closest('.product-grid-item');
  }

  function revertAll() {
    var open = document.querySelectorAll('.' + ACTIVE);
    for (var i = 0; i < open.length; i++) open[i].classList.remove(ACTIVE);
  }

  function selectOption(option) {
    if (option.disabled) return;
    var panel = option.closest('[data-grid-sizes]');
    if (!panel) return;

    var options = panel.querySelectorAll('[data-size-option]');
    for (var i = 0; i < options.length; i++) options[i].classList.remove('is-selected');
    option.classList.add('is-selected');

    var idInput = panel.querySelector('input[name="id"]');
    if (idInput) idInput.value = option.getAttribute('data-variant-id');

    var priceEl = panel.querySelector('[data-size-add-price]');
    var price = option.getAttribute('data-variant-price');
    if (priceEl && price) priceEl.textContent = price;
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-open-sizes]');
    if (opener) {
      event.preventDefault();
      var card = cardOf(opener);
      if (card) {
        revertAll(); // only one card in size-select mode at a time
        card.classList.add(ACTIVE);
      }
      return;
    }

    var option = event.target.closest('[data-size-option]');
    if (option) {
      selectOption(option);
      return;
    }
  });

  // Revert the card once an add succeeds (theme fires these on success).
  document.addEventListener('theme:cart:popdown', revertAll);
  document.addEventListener('theme:cart:reload', revertAll);
  document.addEventListener('theme:cart:change', revertAll);
})();
